import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import ErrorPage from '../Shared/ErrorPage';
import CampaignList from './List.tsx';
import CampaignDecisionBoard from './DecisionBoard/CampaignDecisionBoard.tsx';
import EditCampaignDecisionBoard from './DecisionBoard/EditCampaignDecisionBoard.tsx';
import BookingPlan from './BookingPlan.tsx';

export default function CampaignRoutes() {
  return (
      <Routes>
        <Route path="*" element={<ErrorPage />} />
        <Route path={`/list`} element={<CampaignList />} />
        <Route path={`/campaignDecisionBoard`} element={<CampaignDecisionBoard />} />
        <Route path="/edit/:proposalId" element={<EditCampaignDecisionBoard />} />
       <Route path="/:campaignId/booking-plan" element={<BookingPlan />} />
      </Routes>
  );
}
